var React = require('react');

function XInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.51602 0H15.484C17.9781 0 20 2.03125 20 4.53693V15.4631C20 17.9687 17.9781 20 15.484 20H4.51602C2.02189 20 0 17.9687 0 15.4631V4.53693C0 2.03125 2.02189 0 4.51602 0ZM14.0563 5.82178H12.6453L10.3199 8.4919L8.30977 5.82178H5.39844L8.87695 10.3921L5.58008 14.1779H6.9918L9.53672 11.257L11.7605 14.1779H14.6L10.9738 9.36153L14.0563 5.82178ZM12.932 13.3294H12.15L7.04609 6.62587H7.88516L12.932 13.3294Z"}));
}

XInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = XInline;

XInline.default = XInline;
